import { Component } from "@angular/core";
import { CommonService } from "./core/services/common.service"; 
import { NeverBounceService } from "./core/services/neverbounce.service";
declare global {
  interface Window {
    NeverBounceWidget: any;
    _NBSettings: any;
  }
}
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  title = "Jupiter";
  loading = false
  constructor(
    private commonService: CommonService,
  ) {
    localStorage.getItem('selectTeam') == "N"
    this.commonService.loading$.subscribe((res) => {
      this.loading = res;
    });
  }

  ngOnInit(): void {
    window._NBSettings = {
      apiKey: 'public_ced7b73425dde5f81c0f87cd7962d712'
    };

  }
}
